import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Mail, ArrowLeft } from 'lucide-react';
import API from '../api/axios';
import toast from 'react-hot-toast';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error('يرجى إدخال البريد الإلكتروني');
      return;
    }
    setLoading(true);
    try {
      await API.post('/auth/forgot-password', { email });
      toast.success('إذا كان البريد مسجلًا سنرسل رابط إعادة التعيين');
      navigate('/login');
    } catch (err) {
      toast.error(err.response?.data?.message || 'حدث خطأ');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', background: 'var(--bg-base)' }}>
      <div style={{ width: '100%', maxWidth: '420px' }}>
        <h2 style={{ textAlign: 'center', marginBottom: '24px' }}>استعادة كلمة المرور</h2>
        <form onSubmit={handleSubmit} className="card" style={{ padding: '32px' }}>
          <div className="form-group">
            <label className="form-label"><Mail size={14} /> البريد الإلكتروني</label>
            <input
              type="email"
              className="form-input"
              placeholder="example@email.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              dir="ltr"
            />
          </div>
          <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
            {loading ? 'جاري الإرسال...' : 'إرسال الرابط'}
          </button>
          <div style={{ marginTop: '14px', textAlign: 'center' }}>
            <Link to="/login" style={{ color: 'var(--primary-light)' }}>
              ← العودة لتسجيل الدخول
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
